import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
const $ = window.jQuery;

const SectionNav = {
	init() {
		const $module = $('.wp-section-navigation');

		if (!$module.length) return;

		function scroll_to(elem) {
			$([document.documentElement, document.body]).animate(
				{
					scrollTop: elem.offset().top - 200,
				},
				500
			);
		}

		function fix_sticky_page_nav($el) {
			const header = $('#header');
			const navHeight = header.find('nav.main').outerHeight();
			const adminBar = $('#wpadminbar');
			const adminBarHeight = adminBar.outerHeight();

			let offset = 0;
			if (adminBar.length) {
				offset = +navHeight + +adminBarHeight;
			} else {
				offset = +navHeight;
			}

			const headerFullHeight = $el.parent().offset().top - offset;

			// if scrolled to $module add class sticky-nav to $module
			if ($(window).scrollTop() >= headerFullHeight) {
				$el.addClass('sticky-nav');
				$el.css('top', offset + 'px');
			} else {
				$el.removeClass('sticky-nav');
				$el.css('top', '0');
			}
		}

		$(window).on('scroll', function () {
			fix_sticky_page_nav($module);
		});

		$(window).on('resize', function () {
			fix_sticky_page_nav($module);
		});

		fix_sticky_page_nav($module);

		const $burger = $module.find('.toc-burger button');
		if (!$burger.length) return;

		function close_menu($el) {
			$el.removeClass('mobile-active');
			$el.find('.toc-burger button').removeClass('active');
			enableBodyScroll($el[0]);
		}

		$burger.on('click', function () {
			$(this).toggleClass('active');
			$(this).closest('ul.toc').toggleClass('mobile-active');
			if ($(this).hasClass('active')) {
				disableBodyScroll($('ul.toc')[0]);

				$('ul.toc li a').one('click', function () {
					close_menu($(this).closest('ul.toc'));
				});
			} else {
				enableBodyScroll($('ul.toc')[0]);
			}
		});
	},
};

export default SectionNav;
